import { useApplicationQuery, useCreateApplicationMutation, useUpdateApplicationMutation, useDeleteApplicationMutation } from './useApplicationsQuery';
import { Application } from '../types';

export const useApplication = (applicationId?: string) => {
    const { data: record, isLoading: loading, refetch: fetchRecord } = useApplicationQuery(applicationId || '');
    const createApplicationMutation = useCreateApplicationMutation();
    const updateApplicationMutation = useUpdateApplicationMutation();
    const deleteApplicationMutation = useDeleteApplicationMutation();

    const createRecord = async (values: Application) => {
        return await createApplicationMutation.mutateAsync(values);
    };

    const updateRecord = async (values: Application) => {
        if (typeof applicationId === 'undefined') {
            throw new Error('applicationId is required parameter');
        }
        return await updateApplicationMutation.mutateAsync({ id: applicationId, record: values });
    };

    const deleteRecord = async () => {
        if (typeof applicationId === 'undefined') {
            throw new Error('applicationId is required parameter');
        }
        return await deleteApplicationMutation.mutateAsync(applicationId);
    };

    return {
        record,
        loading,
        fetchRecord,
        createRecord,
        updateRecord,
        deleteRecord,
    };
};
